import React from 'react'
import {truncate} from 'lodash'
import AdminTableField from "./AdminTableField";

function AdminTableRow(props) {

    const {
        onClick,
        item,
        index,
        showChilds,
        showChildHeader,
        columns,
        childColumns,
        showDetails,
        isChildRow,
        viewType
    } = props

    let returnArray = []
    returnArray.push(
        <tr onClick={onClick} className={(showChilds ? 'primary-table-row' : '')} key={index + '-1'}>
            {!isChildRow && false && <td>{index + 1}</td>}
            {columns.map((value, index) => {
                if (value.type === 'value') {
                    return (
                        <td className={isChildRow ? value.childClassName : value.className}
                            style={{minWidth: value.width}}
                            key={index}>
                            {(!isChildRow && false && index === 0) &&
                            <span className="show-details-toggle" onClick={() => showDetails(item.id)}
                                  className="float-left mr-2">
                        <i className={!showChilds ? "fas fa-caret-right" : "fas fa-caret-down"}></i>
                      </span>
                            }
                            {(value.editable || value.actions) &&
                            <AdminTableField item={item} column={value} viewType={viewType} />}
                            {!(value.editable || value.actions) && <>
                                {value.alias.map((aliasValue, aliasIndex) => {
                                        let valueLabel = truncate(item[aliasValue], {length: value.truncate ? value.truncate : 30});
                                        if (value.valueLabels) {
                                            const status = valueLabel
                                            valueLabel = value.valueLabels[valueLabel]
                                            return <span className={'status-icon status-' + status} title={valueLabel}
                                                         key={aliasIndex}>{status}</span>
                                        }
                                        return <span
                                            title={item[aliasValue] && item[aliasValue].length > (value.truncate ? value.truncate : 30) ? item[aliasValue] : null}
                                            key={aliasIndex}
                                            className="d-inline mr-2">{value.prefix && value.prefix}{valueLabel}{value.postfix && value.postfix}</span>
                                    }
                                )}
                                {value.actions && value.actions.map((actionValue, actionIndex) => {
                                        if (actionValue.alias === 'sendSms') {
                                            return (
                                                <span key={'a-' + actionIndex}
                                                      className="text-primary float-right cursor-pointer ml-1"
                                                      onClick={() => this.onSendSms(item[actionValue.labelField], item[actionValue.idField])}><i
                                                    className="fas fa-sms"></i></span>
                                            )
                                        }
                                        if (actionValue.alias === 'bookingLink') {
                                            return (
                                                <a key={'a-' + actionIndex}
                                                   className="text-primary float-right cursor-pointer ml-1"
                                                   target="_blank"
                                                   href={'/profile/messages/' + item[actionValue.idField]}><i
                                                    className="fas fa-file-signature"></i></a>
                                            )
                                        }
                                        if (actionValue.alias === 'boatLink') {
                                            return (

                                                <a key={'a-' + actionIndex}
                                                   className="text-primary float-right cursor-pointer ml-1"
                                                   target="_blank"
                                                   href={'/profile/boat/' + item[actionValue.idField]}><i
                                                    className="fas fa-ship"></i></a>
                                            )
                                        }
                                        if (actionValue.alias === 'sendEmail') {
                                            return (
                                                <a key={'a-' + actionIndex}
                                                   className="text-primary float-right cursor-pointer ml-1"
                                                   href={'mailto:' + item[actionValue.labelField]} target="_blank"><i
                                                    className="fas fa-envelope"></i></a>
                                            )
                                        }
                                    }
                                )
                                }</>
                            }
                        </td>
                    )
                } else if (value.type === 'status') {
                    return (
                        <td className={isChildRow ? value.childClassName : value.className}
                            style={{minWidth: value.width}}
                            key={index}>
                            <div className='status-circle-wrapper'>
                                <div
                                    className={'status-circle status-circle-first status-circle-' + item[value.alias]}></div>
                            </div>
                        </td>
                    )
                }
            })}
        </tr>
    )
    if (showChilds) {
        returnArray.push(
            <tr className='has-child-table' key={index + '-2'}>
                <td colSpan={columns.length + 1} className='p-0'>
                    <table className={(showChildHeader ? 'show-child-header' : '') + ' table child-table m-0'}>
                        {showChildHeader && <thead>
                        <tr>
                            {childColumns.map((value, index) => (
                                <th scope="col" key={index}>{value.label}</th>
                            ))}
                        </tr>
                        </thead>
                        }
                        <tbody>
                        {item.childs.map((value, index) => (
                            <AdminTableRow
                                item={value}
                                key={index}
                                showChilds={false}
                                columns={childColumns}
                                isChildRow={true}
                            />
                        ))
                        }
                        </tbody>
                    </table>
                </td>
            </tr>
        )
    }
    return returnArray
}

export default AdminTableRow
